
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { motion } from "framer-motion";

interface LoginPageLayoutProps {
  children: ReactNode;
  loaded: boolean;
}

const LoginPageLayout = ({ children, loaded }: LoginPageLayoutProps) => {
  return (
    <div className="min-h-screen flex overflow-hidden relative">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-black/95 to-anzir/50 z-0" />
      
      <div className="flex w-full flex-col md:flex-row items-stretch">
        {children}
      </div>
    </div>
  );
};

export default LoginPageLayout;
